export const BUSINESS_TYPES = [
  'agriculture', 'dairy', 'livestock', 'retail', 'grocery', 'restaurant',
  'hotel', 'transportation', 'medical', 'education', 'manufacturing',
  'services', 'handicrafts', 'tourism', 'other',
];

export const CONSTITUTION_TYPES = [
  'proprietorship', 'partnership', 'company', 'cooperative', 'trust',
  'self_help_group', 'government', 'other',
];

export const PARTY_ROLE_TYPES = [
  'proprietor', 'partner', 'director', 'trustee', 'operator',
  'authorized_signatory', 'contact', 'other',
];

export const OCCUPANCY_TYPES = ['owner', 'tenant', 'licensee', 'operator', 'other'];

export const GRANT_SCOPES = [
  'view', 'manage_profile', 'manage_locations', 'manage_tax', 'pay',
  'view_receipts', 'download_receipts', 'submit_documents',
  'submit_tax_declaration',
];

export const STATUS_LABELS = {
  draft: 'मसुदा / Draft',
  pending: 'तपासणीसाठी / Pending',
  verified: 'पडताळलेले / Verified',
  rejected: 'नाकारलेले / Rejected',
  suspended: 'निलंबित / Suspended',
  archived: 'संग्रहित / Archived',
};

export const TYPE_LABELS = {
  agriculture: 'कृषी / Agriculture', dairy: 'दुग्ध व्यवसाय / Dairy',
  livestock: 'पशुपालन / Livestock', retail: 'किरकोळ / Retail',
  grocery: 'किराणा / Grocery', restaurant: 'उपहारगृह / Restaurant',
  hotel: 'हॉटेल / Hotel', transportation: 'वाहतूक / Transportation',
  medical: 'वैद्यकीय / Medical', education: 'शिक्षण / Education',
  manufacturing: 'उत्पादन / Manufacturing', services: 'सेवा / Services',
  handicrafts: 'हस्तकला / Handicrafts', tourism: 'पर्यटन / Tourism',
  other: 'इतर / Other',
};

export const CONSTITUTION_LABELS = {
  proprietorship: 'एकल मालकी / Proprietorship', partnership: 'भागीदारी / Partnership',
  company: 'कंपनी / Company', cooperative: 'सहकारी संस्था / Cooperative',
  trust: 'ट्रस्ट / Trust', self_help_group: 'स्वयं-सहायता गट / SHG',
  government: 'शासकीय / Government', other: 'इतर / Other',
};

export const ROLE_LABELS = {
  proprietor: 'मालक / Proprietor', partner: 'भागीदार / Partner',
  director: 'संचालक / Director', trustee: 'विश्वस्त / Trustee',
  operator: 'चालक / Operator', authorized_signatory: 'अधिकृत स्वाक्षरीकर्ता',
  contact: 'संपर्क व्यक्ती / Contact', other: 'इतर / Other',
};

export const READINESS_LABELS = {
  business_category: 'व्यवसायाची कर वर्गवारी / उप-वर्ग आवश्यक',
  employees_count: 'कर्मचारी संख्या आवश्यक आहे; कर्मचारी नसल्यास 0 भरा',
  annual_turnover: 'अचूक संख्यात्मक वार्षिक उलाढाल आवश्यक आहे; उलाढाल नसल्यास 0 भरा',
  primary_location_floor_area: 'प्राथमिक व्यवसाय ठिकाणाचे क्षेत्रफळ आवश्यक',
  primary_location_signage_area: 'प्राथमिक ठिकाणाचे फलक क्षेत्र आवश्यक आहे; फलक नसल्यास 0 भरा',
  registration_type: 'नोंदणी प्रकार आवश्यक आहे; नोंदणी नसल्यास Unregistered निवडा',
  registration_number: 'निवडलेल्या नोंदणी प्रकारासाठी नोंदणी क्रमांक आवश्यक आहे',
  verified_active_business: 'व्यवसाय सक्रिय आणि पडताळलेला असणे आवश्यक',
  primary_liable_party: 'एक प्राथमिक कर-दायित्व असलेली व्यक्ती आवश्यक',
  primary_location: 'एक प्राथमिक व्यवसाय ठिकाण आवश्यक',
  ownership_and_role_validation: 'मालकी हिस्सा आणि भूमिका नियम पूर्ण करणे आवश्यक',
};

export const todayIso = () => new Date().toISOString().slice(0, 10);

export const emptyRole = () => ({
  party_uid: '', role_type: 'proprietor', ownership_share: '100',
  is_primary: true, is_liable_party: true, valid_from: todayIso(), valid_to: '',
  evidence_note: '', evidence_attestation: false,
});

export const emptyLocation = () => ({
  property_uid: '', branch_name: '', address_line_1: '', address_line_2: '',
  locality: '', ward_number: '', pincode: '', occupancy_type: 'operator',
  floor_area_sqft: '', signage_area_sqft: '', latitude: '', longitude: '',
  is_primary: true, valid_from: todayIso(), valid_to: '', milkat_number: '',
});

export const emptyBusiness = () => ({
  business_name: '', owner_name: '', legal_name: '', constitution_type: 'proprietorship',
  business_type: 'retail', business_category: '', description: '', address: '',
  phone: '', email: '', website: '', registration_number: '', registration_type: '',
  gstin: '', pan_last4: '', employees_count: '', annual_turnover: '',
  products_services: '', latitude: '', longitude: '', business_image_url: '',
  owner_photo_url: '', opening_hours: '', contact_person: '',
  contact_person_phone: '', establishment_year: '', commenced_on: todayIso(),
});

const nullableNumeric = new Set(['employees_count', 'latitude', 'longitude', 'establishment_year']);

export const cleanBusinessPayload = form => Object.fromEntries(
  Object.entries(emptyBusiness()).map(([key]) => {
    const value = form[key];
    if (nullableNumeric.has(key)) return [key, value === '' || value === null ? null : Number(value)];
    return [key, typeof value === 'string' ? value.trim() || null : value];
  })
);

export const cleanRolePayload = role => ({
  party_uid: role.party_uid,
  role_type: role.role_type,
  ownership_share: ['proprietor', 'partner'].includes(role.role_type)
    ? (role.ownership_share === '' ? null : Number(role.ownership_share))
    : null,
  is_primary: Boolean(role.is_primary),
  is_liable_party: Boolean(role.is_liable_party),
  valid_from: role.valid_from || null,
  valid_to: role.valid_to || null,
  evidence: {
    note: role.evidence_note?.trim() || null,
    attestation: Boolean(role.evidence_attestation),
  },
});

export const cleanLocationPayload = location => ({
  property_uid: location.property_uid || null,
  branch_name: location.branch_name?.trim() || (location.milkat_number ? `मिळकत क्र. ${location.milkat_number}` : null),
  address_line_1: location.address_line_1?.trim(),
  address_line_2: location.address_line_2?.trim() || null,
  locality: location.locality?.trim() || null,
  ward_number: location.ward_number?.trim() || null,
  pincode: location.pincode?.trim() || null,
  latitude: location.latitude === '' ? null : Number(location.latitude),
  longitude: location.longitude === '' ? null : Number(location.longitude),
  occupancy_type: location.occupancy_type,
  floor_area_sqft: location.floor_area_sqft === '' ? null : Number(location.floor_area_sqft),
  signage_area_sqft: location.signage_area_sqft === '' ? null : Number(location.signage_area_sqft),
  is_primary: Boolean(location.is_primary),
  valid_from: location.valid_from || null,
  valid_to: location.valid_to || null,
});

export const errorMessage = (error, fallback = 'Request failed') => {
  const response = error?.response?.data;
  const details = response?.details;
  if (Array.isArray(details) && details.length) {
    return details.map(item => item.message || item.field || item.scope || String(item)).join('; ');
  }
  return response?.error || response?.message || error?.message || fallback;
};

export const activeRecords = records => (records || []).filter(item => !item.status || item.status === 'active');

export const isUnregisteredBusiness = value => ['unregistered', 'not_applicable', 'not applicable', 'none']
  .includes(String(value || '').trim().toLowerCase().replaceAll('-', '_'));

export const clientReadiness = (business, roles, locations) => {
  const activeRoles = activeRecords(roles);
  const activeLocations = activeRecords(locations);
  const missing = [];
  if (!activeRoles.some(role => role.is_primary && role.is_liable_party)) missing.push('primary_liable_party');
  if (activeLocations.filter(location => location.is_primary).length !== 1) missing.push('primary_location');
  if (!String(business.business_category || '').trim()) missing.push('business_category');
  if (business.employees_count === '' || business.employees_count === null || business.employees_count === undefined) {
    missing.push('employees_count');
  }
  if (!/^(?:0|[1-9]\d*)(?:\.\d+)?$/.test(String(business.annual_turnover ?? '').trim())) {
    missing.push('annual_turnover');
  }
  // registration_number is optional for local panchayat tax assessment
  const primaryLocation = activeLocations.find(location => location.is_primary);
  if (!primaryLocation || Number(primaryLocation.floor_area_sqft) <= 0) {
    missing.push('primary_location_floor_area');
  }
  if (!primaryLocation || primaryLocation.signage_area_sqft === '' || primaryLocation.signage_area_sqft === null
    || primaryLocation.signage_area_sqft === undefined || Number(primaryLocation.signage_area_sqft) < 0) {
    missing.push('primary_location_signage_area');
  }

  const equity = activeRoles.filter(role => ['proprietor', 'partner'].includes(role.role_type));
  const total = equity.reduce((sum, role) => sum + Number(role.ownership_share || 0), 0);
  if (business.constitution_type === 'proprietorship') {
    const proprietors = equity.filter(role => role.role_type === 'proprietor');
    if (proprietors.length !== 1 || Math.abs(Number(proprietors[0]?.ownership_share) - 100) > 0.0001) {
      missing.push('ownership_and_role_validation');
    }
  } else if (business.constitution_type === 'partnership') {
    const partners = equity.filter(role => role.role_type === 'partner');
    const partnerTotal = partners.reduce((sum, role) => sum + Number(role.ownership_share || 0), 0);
    if (partners.length < 2 || Math.abs(partnerTotal - 100) > 0.0001) missing.push('ownership_and_role_validation');
  } else if (equity.some(role => role.ownership_share === null || role.ownership_share === '')) {
    missing.push('ownership_and_role_validation');
  } else if (total > 100.0001) {
    missing.push('ownership_and_role_validation');
  }

  return { ready: missing.length === 0, missing: [...new Set(missing)], ownershipTotal: total };
};
